import React, { Component } from 'react';
import App_data from '../config/App_data';
import FD from '../RestAPI/fetchData';
import Loader from '../../common/loader';
import '../../assets/css/subscribe.css';
import { showFailure, showInformation } from '../../common/toast';
import { formatMoney, formatPrettyDate } from '../../utils/CommonUtils';
import userStore from '../../store/userStore';
import { trackAddToCart } from '../../common/analytics';
import { getSubscriptionBadge, getSubscriptionDateLabel } from '../../common/subscriptionBadge';

/* eslint-disable*/

// Two rows is the ceiling (2026-09-01) — three overflowed the card.
const MAX_TILE_ENTITLEMENTS = 2;

const entitlementTier = (item) => {
  const v = String((item && item.package_val) || '').toLowerCase();
  if (v === 'plus') return 4;
  if (v === 'unlimited') return 3;
  if (v === 'expensive') return 2;
  if (v === 'simple') return 1;
  return 0;
};

// Mirrors SelectPackage.isIncludedInPurchasedPackage's generic branch:
// getPlanRank = tier * 1e6 + price * 1e3 + id, compared within the mock /
// non-mock group. Owning "Mock Unlimited (All 3 Levels)" therefore hides
// "Mock (Learn + Practice)" here exactly as the plan card marks it
// "Included in Purchased Package".
const entitlementRank = (item) =>
  entitlementTier(item) * 1000000 +
  Number((item && item.price) || 0) * 1000 +
  Number((item && item.planId) || 0);

const isMockEntitlement = (item) => !!(item && item.package_category === 'mock');

const filterVisibleEntitlements = (entitlements) => {
  const list = Array.isArray(entitlements) ? entitlements : [];
  if (list.length < 2) return list;

  // A non-mock unlimited package covers every mock package for the course.
  let hasNonMockUnlimited = false;
  for (let i = 0; i < list.length; i++) {
    if (!isMockEntitlement(list[i]) && entitlementTier(list[i]) >= 3) {
      hasNonMockUnlimited = true;
    }
  }

  let maxMockRank = -1;
  let maxOtherRank = -1;
  for (let i = 0; i < list.length; i++) {
    const r = entitlementRank(list[i]);
    if (isMockEntitlement(list[i])) {
      if (r > maxMockRank) maxMockRank = r;
    } else if (r > maxOtherRank) maxOtherRank = r;
  }

  const kept = [];
  for (let i = 0; i < list.length; i++) {
    const item = list[i];
    const isMock = isMockEntitlement(item);
    if (isMock && hasNonMockUnlimited) continue;
    const groupMax = isMock ? maxMockRank : maxOtherRank;
    if (entitlementRank(item) < groupMax) continue;
    kept.push(item);
  }

  // Never blank the card: if the rules removed everything, fall back to the
  // unfiltered list.
  return (kept.length ? kept : list).slice(0, MAX_TILE_ENTITLEMENTS);
};

class Subscribe extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      courseCategories: [],
      expandedCourseKey: null,
      selectedAddonsByCourse: {},
      errorMessage: "",
      activeExtrasCourseKey: null,
      isAddingToCart: false
    };

    this.onToggleExpand = this.onToggleExpand.bind(this);
    this.onToggleAddon = this.onToggleAddon.bind(this);
    this.onAddExtrasToCart = this.onAddExtrasToCart.bind(this);
    this.onSelectCourse = this.onSelectCourse.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.onDocClick, false);
    this.loadCourses();
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.onDocClick, false);
  }

  async loadCourses() {
    this.setState({ isLoading: true, errorMessage: "" });

    FD.callAPI(App_data.backend_api + "/checkout_v1/getAllExamPackagesByUserId")
      .then((resp) => {
        if (resp && resp.success) {
          this.setState({
            isLoading: false,
            courseCategories: resp.coursesByGroup,
            errorMessage: "",
          });
        } else {
          const msg = (resp && resp.message) ? resp.message : "Failed to load courses";
          this.setState({
            isLoading: false,
            courseCategories: [],
            errorMessage: msg,
          });
          showInformation(msg);
        }
        return resp;
      })
      .catch((err) => {
        console.log(err)
        this.setState({
          isLoading: false,
          courseCategories: [],
          errorMessage: "Error loading courses",
        });
        showFailure("Error loading courses");
      });
  }

  priceLabel(priceRange) {
    const pr = priceRange || { min: 0, max: 0 };
    const min = Number(pr.min || 0);
    const max = Number(pr.max || 0);
    if (min === max) return formatMoney(min);
    return formatMoney(min) + " - " + formatMoney(max);
  }

  onSelectCourse(uiKey, primaryExamId) {
    if (!uiKey || !primaryExamId) return;
    this.props.router.push(
      `/subscribe/selectPackage/${uiKey}/${primaryExamId}`
    );
  }

  onDocClick = (e) => {
    if (!this.state.expandedCourseKey) return;

    const panel = e.target.closest && e.target.closest(".sb_enhance_panel");
    const button = e.target.closest && e.target.closest(".sb_card_button_enhance");
    if (panel || button) return;

    this.setState({ expandedCourseKey: null });
  };

  onToggleExpand(uiKey) {
    const current = this.state.expandedCourseKey;
    this.setState({
      expandedCourseKey: current === uiKey ? null : uiKey,
    });
  }

  onToggleAddon(uiKey, addonId) {
    let selectedMap = this.state.selectedAddonsByCourse || {};
    let activeKey = this.state.activeExtrasCourseKey;

    if (activeKey && activeKey !== uiKey) {
      selectedMap = {};
      activeKey = uiKey;
    } else if (!activeKey) {
      activeKey = uiKey;
    }

    const curCourseMap = selectedMap[uiKey] || {};
    const nextCourseMap = Object.assign({}, curCourseMap);

    if (nextCourseMap[addonId]) {
      delete nextCourseMap[addonId];
    } else {
      nextCourseMap[addonId] = true;
    }

    const hasAny = Object.keys(nextCourseMap).length > 0;

    const nextSelectedMap = Object.assign({}, selectedMap);
    if (hasAny) nextSelectedMap[uiKey] = nextCourseMap;
    else delete nextSelectedMap[uiKey];

    this.setState({
      selectedAddonsByCourse: nextSelectedMap,
      activeExtrasCourseKey: hasAny ? activeKey : null
    });
  }

  /**
   * Walk courseCategories to find the course by uiKey.
   */
  findCourseByUiKey(uiKey) {
    const cats = this.state.courseCategories || [];
    for (let i = 0; i < cats.length; i++) {
      const items = (cats[i] && cats[i].dataItems) || [];
      for (let j = 0; j < items.length; j++) {
        if (items[j] && items[j].uiKey === uiKey) return items[j];
      }
    }
    return null;
  }

  /**
   * Fire conversion tracking after addons are successfully added to cart.
   * Sums the prices of the selected addons for the analytics value.
   */
  fireAddonsAddToCartTracking(uiKey, addonIds, purchasedCourse) {
    try {
      const course = this.findCourseByUiKey(uiKey);
      const addons = (course && course.addons && (course.addons.remaining || course.addons.available)) || [];
      const idSet = new Set(addonIds.map(Number));

      let value = 0;
      for (let i = 0; i < addons.length; i++) {
        const a = addons[i];
        if (a && idSet.has(Number(a.id))) {
          value += Number(a.price) || 0;
        }
      }

      const profile = (userStore && userStore.profileInfo) || {};
      trackAddToCart({
        exam: (course && course.uiTitle) || '',
        packageType: (purchasedCourse && purchasedCourse.package_type)
          || (course && course.uiTitle ? course.uiTitle + ' — Add-ons' : 'Add-ons'),
        value,
        userName: profile.username || '',
        userEmail: profile.email || '',
        source: (userStore && userStore.landingSource) || 'organic',
        affiliateName: (userStore && userStore.landingSourceName) || null,
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('Subscribe addons trackAddToCart failed:', e && e.message);
    }
  }

  onAddExtrasToCart(purchasedCourse) {
    if (!purchasedCourse) return;

    const examId = Number(purchasedCourse.exam_id || 0);
    const planId = Number(purchasedCourse.package_id || 0);

    if (!(examId > 0) || !(planId > 0)) {
      showInformation("Missing examId or planId for this course.");
      return;
    }

    const selectedMap = this.state.selectedAddonsByCourse || {};
    const activeKey = this.state.activeExtrasCourseKey;

    if (!activeKey || !selectedMap[activeKey]) {
      showInformation("Please select add-ons first.");
      return;
    }

    const courseMap = selectedMap[activeKey] || {};
    const addonIds = Object.keys(courseMap)
      .map(function (k) { return Number(k); })
      .filter(function (n) { return Number.isFinite(n) && n > 0; });

    if (!addonIds.length) {
      showInformation("Please select add-ons first.");
      return;
    }

    if (this.state.isAddingToCart) return;

    this.setState({ isAddingToCart: true });

    FD.callAPI(App_data.backend_api + "/checkout_v1/addToUserCart", {
      examId: examId,
      planId: planId,
      addonIds: addonIds,
      type: "unlessUnlimited"
    })
      .then((resp) => {
        if (resp && resp.success) {
          // Conversion tracking — fire GTM/GA4/FB AddToCart events for the
          // addons being added. Mirrors the legacy SelectExtras.js behaviour.
          this.fireAddonsAddToCartTracking(activeKey, addonIds, purchasedCourse);

          this.setState({
            selectedAddonsByCourse: {},
            activeExtrasCourseKey: null,
            isAddingToCart: false
          });

          this.props.router.push("/cart");
        } else {
          const msg = (resp && resp.message) ? resp.message : "Failed to add add-ons to cart";
          showInformation(msg);
          this.setState({ isAddingToCart: false });
        }
        return resp;
      })
      .catch(() => {
        showFailure("Failed to add add-ons to cart");
        this.setState({ isAddingToCart: false });
      });
  }

  renderCourseCard(course, key) {
    if (!course) return null;

    const {
      status = "none",
      uiKey = "",
      primaryExamId = null,
      addons = {},
      purchasedCourse = null,
      hasLifetimeAccess = false,
      hasUnlimitedTutor = false,
      purchaseDate = null,
      expirationDate = null,
      includedBy = null,
      uiTitle = "",
      priceRange = null,
      subscription = null,
      entitlements = [],
    } = course;

    const isPurchased = status === "purchased" && !!purchasedCourse;
    const isIncluded = status === "included";
    const isOwnedLike = isPurchased || isIncluded;

    const abbr = key === "soa" ? "AE" : String(key || "").toUpperCase();
    const expanded = this.state.expandedCourseKey === uiKey;

    const remaining = (addons && addons.remaining) || [];
    const selectedMap = (this.state.selectedAddonsByCourse || {})[uiKey] || {};
    const selectedIds = Object.keys(selectedMap);

    const canEnhance = isPurchased && remaining.length > 0;

    if (isOwnedLike) {
      let badgeText = "Purchased";
      let planName = "—";

      if (isPurchased) {
        planName = (purchasedCourse && purchasedCourse.package_type) || "—";
        // Shared vocabulary — see src/common/subscriptionBadge.js
        badgeText = getSubscriptionBadge(subscription).label;
      }

      if (isIncluded) {
        badgeText = "Included";
        const srcType = (includedBy && includedBy.package_type) || "Unlimited package";
        // planName = `${srcType} Bundle`;
        planName = srcType;
      }

      const purchasedPretty = isPurchased ? formatPrettyDate(purchaseDate) : null;
      const expiresPretty = isPurchased ? formatPrettyDate(expirationDate) : null;

      // A course can carry several live entitlements at once — a mock package
      // alongside a monthly subscription. The flat fields above describe only
      // the primary one, so the rest were invisible. A single entitlement keeps
      // the original markup exactly, so nothing moves for the common case.
      const tileEntitlements = filterVisibleEntitlements(entitlements);
      const showEntitlementList = isPurchased && tileEntitlements.length > 1;

      return (
        <div
          className={"sb_page_container_card" + (isIncluded ? " sb_card_included" : "")}
          key={uiKey}
          // onClick={() => this.onSelectCourse(uiKey, primaryExamId)}
          onClick={() => !isIncluded ? this.onSelectCourse(uiKey, primaryExamId) : null}
        >
          <div className="sb_container_card_header">
            <div className={"sb_card_header_icon" + (isIncluded ? " sb_card_header_icon_included" : "")}>
              <span className="sb_header_icon_text">{abbr}</span>
            </div>

            <div className="sb_card_header_info">
              <div className="sb_header_info_row">
                <div className="sb_header_info_title">{uiTitle}</div>
                <div
                  className={
                    "sb_header_info_badge_purchased" +
                    (isIncluded ? " sb_header_info_badge_included" : "") +
                    (isPurchased
                      ? " sb_badge_tone_" + getSubscriptionBadge(subscription).tone
                      : "")
                  }
                >
                  {badgeText}
                </div>
              </div>

              <div className="sb_header_info_subtitle">{planName}</div>
            </div>
          </div>

          {showEntitlementList && (
            <div className="sb_container_card_meta">
              {tileEntitlements.map((item, idx) => {
                const itemSub = item.subscription || null;
                const itemBadge = getSubscriptionBadge(itemSub);
                const itemExpiry =
                  itemSub && itemSub.expiryDate
                    ? formatPrettyDate(itemSub.expiryDate)
                    : item.expirationDate
                      ? formatPrettyDate(item.expirationDate)
                      : null;
                const itemPurchased = item.purchaseDate
                  ? formatPrettyDate(item.purchaseDate)
                  : null;

                return (
                  <div className="sb_card_entitlement" key={item.planId || idx}>
                    <div className="sb_card_meta_row">
                      <span
                        className={
                          "sb_header_info_badge_purchased sb_badge_tone_" + itemBadge.tone
                        }
                      >
                        {itemBadge.label}
                      </span>
                      <span className="sb_card_entitlement_name">
                        {item.package_type || "—"}
                      </span>
                    </div>

                    {(item.hasLifetimeAccess || item.hasUnlimitedTutor) && (
                      <div className="sb_card_meta_row sb_card_meta_row_green">
                        {item.hasLifetimeAccess && (
                          <div className="sb_card_meta_row">
                            <span className="sb_card_meta_icon sb_card_meta_icon_infinity" />
                            <span>Lifetime</span>
                          </div>
                        )}

                        {item.hasUnlimitedTutor && (
                          <div className="sb_card_meta_row">
                            <span className="sb_card_meta_icon sb_card_meta_icon_chat" />
                            <span>Unlimited Tutor</span>
                          </div>
                        )}
                      </div>
                    )}

                    {itemExpiry && !item.hasLifetimeAccess && (
                      <div className="sb_card_meta_row sb_card_meta_row_grey">
                        <span className="sb_card_meta_icon sb_card_meta_icon_clock" />
                        <span>{getSubscriptionDateLabel(itemSub) + itemExpiry}</span>
                      </div>
                    )}

                    {itemPurchased && (
                      <div className="sb_card_meta_row sb_card_meta_row_grey">
                        <span className="sb_card_meta_icon sb_card_meta_icon_calendar" />
                        <span>
                          {(itemSub ? "Subscribed: " : "Purchased: ") + itemPurchased}
                        </span>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}

          {isPurchased && !showEntitlementList && (
            <div className="sb_container_card_meta">
              <div className="sb_card_meta_row sb_card_meta_row_green">
                {hasLifetimeAccess && (
                  <div className="sb_card_meta_row">
                    <span className="sb_card_meta_icon sb_card_meta_icon_infinity" />
                    <span>Lifetime</span>
                  </div>
                )}

                {hasUnlimitedTutor && (
                  <div className="sb_card_meta_row">
                    <span className="sb_card_meta_icon sb_card_meta_icon_chat" />
                    <span>Unlimited Tutor</span>
                  </div>
                )}
              </div>

              {expiresPretty && (
                <div className="sb_card_meta_row sb_card_meta_row_grey">
                  <span className="sb_card_meta_icon sb_card_meta_icon_clock" />
                  <span>{getSubscriptionDateLabel(subscription) + expiresPretty}</span>
                </div>
              )}

              {purchasedPretty && (
                <div className="sb_card_meta_row sb_card_meta_row_grey">
                  <span className="sb_card_meta_icon sb_card_meta_icon_calendar" />
                  <span>
                    {(subscription ? "Subscribed: " : "Purchased: ") + purchasedPretty}
                  </span>
                </div>
              )}
            </div>
          )}

          {canEnhance && (
            <div className="sb_container_card_enhance" onClick={(e) => e.stopPropagation()}>
              <button
                type="button"
                className="sb_card_button_enhance"
                onClick={() => this.onToggleExpand(uiKey)}
              >
                <span className="sb_enhance_plus">+</span> Enhance Your Package
              </button>

              {expanded && (
                <div className="sb_enhance_panel">
                  <div className="sb_enhance_panel_title">Enhance Your Package</div>

                  <div className="sb_enhance_panel_list">
                    {remaining.map((addon) => {
                      const aid = String(addon.id);
                      const checked = !!selectedMap[aid];

                      return (
                        <div
                          key={aid}
                          className={"sb_enhance_panel_item" + (checked ? " sb_enhance_panel_item_active" : "")}
                          onClick={() => this.onToggleAddon(uiKey, aid)}
                        >
                          <input
                            type="checkbox"
                            checked={checked}
                            onChange={() => this.onToggleAddon(uiKey, aid)}
                            onClick={(e) => e.stopPropagation()}
                          />

                          <div className="sb_panel_item_name">{addon.title}</div>

                          {addon.tooltip_description && (
                            <span className="sb_addon_tooltip_wrap">
                              <span className="sb_addon_tooltip_icon" aria-label="Info">i</span>
                              <span className="sb_addon_tooltip_popup">
                                {String(addon.tooltip_description).replace(/<[^>]*>/g, "")}
                              </span>
                            </span>
                          )}

                          <div className="sb_panel_item_price">{formatMoney(addon.price)}</div>
                        </div>
                      );
                    })}
                  </div>

                  {selectedIds.length > 0 && (
                    <button
                      type="button"
                      className="sb_enhance_panel_add_button"
                      onClick={() => this.onAddExtrasToCart(purchasedCourse)}
                    >
                      Add {selectedIds.length} Extra{selectedIds.length > 1 ? "s" : ""} to Cart
                    </button>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      );
    }

    return (
      <button
        type="button"
        key={uiKey}
        className="sb_page_container_card sb_card_not_purchased"
        onClick={() => this.onSelectCourse(uiKey, primaryExamId)}
      >
        <div className="sb_container_card_header">
          <div className="sb_card_header_icon sb_icon_not_purchased">
            <span className="sb_header_icon_text sb_icon_text_not_purchased">{abbr}</span>
          </div>

          <div className="sb_card_header_info">
            <div className="sb_header_info_row">
              <div className="sb_header_info_title">{uiTitle}</div>
            </div>

            <div className="sb_header_info_subtitle">
              {this.priceLabel(priceRange)}
            </div>
          </div>
        </div>
      </button>
    );
  }

  renderCategory(category) {
    const items = category.dataItems || [];

    return (
      <div className="sb_container_category" key={category.key}>
        <div className="sb_category_header">
          <div className="sb_category_header_title">
            {category.title}{" "}
            <span className="sb_category_header_count">
              ({items.length} {items.length === 1 ? "exam" : "exams"})
            </span>
          </div>
        </div>

        <div className="sb_page_container_grid">
          {items.map((course) => this.renderCourseCard(course, category.key))}
        </div>
      </div>
    );
  }

  render() {
    const { isLoading, courseCategories, errorMessage } = this.state;

    if (isLoading) {
      return (
        <div className='animated fadeIn'>
          <Loader />
        </div>
      );
    }

    return (
      <div className='animated fadeIn'>
        <div className="sb_page_container">
          {errorMessage ? (
            <div className="sb_error_message">{errorMessage}</div>
          ) : (
            <div>
              <div className="sb_container_header">
                <h1 className="sb_container_title">Pick Your Exam Plan</h1>
              </div>
              {courseCategories.map((c) => this.renderCategory(c))}
            </div>
          )}
        </div>
      </div>
    );
  }
}

// import language from '../../assets/languages/language';
// import GD from '../RestAPI/getData';
// import {autorun} from "mobx";
// import userStore from "../../store/userStore";

/* class Subscribe extends Component { // old flow
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      MessageTitle: `${language.LC().ALERT}`,
      MessageContent: `${language.LC().ERROR}`,
      exams: [],
      token: '',
      idname: '',
      ValidToken: false,
      chapter_id: '',
      offset: 0,
      limit: 10,
      answered: [],
      plan_data: '',
      pack_class: 'hide_block',
      exam_name: '',
      exam_class: 'row',
      extras_1: false,
      extras_2: false,
      checkedStatus: false,
      disable: false,
      selectedMenu: '',
      // China_price: "",
      China_price: 6.55,
      canadian_price: 5.22,
      usd_canadian_price: 1.26,
      userRole: '',
    };
    this.toggleAlert = this.toggleAlert.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  toggleAlert() {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  }

  _getPackages = (item, e) => {
    this.context.router.push({
      pathname: `/subscribe/selectPackage/${item.exam_name}/${item.id}`,
      state: {
        exam: {
          exam_id: item.id,
          name: item.name,
        },
        China_price: this.state.China_price,
      },
    });
  };
  getChinaPrice = () => {
    GD.GetCallAPI('https://api.exchangeratesapi.io/latest?base=USD').then(resp => {
      // console.log("resunfnvd", resp);
      // console.log("resunfnvd", resp.rates.CNY);
      this.setState({
        China_price: resp.rates.CNY,
      });
    });
  };
  componentDidMount() {
    // this.getChinaPrice();
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    var selectedMenu = localStorage.getItem('selectedmenu');

    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
      selectedMenu: selectedMenu,
    });

    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    FD.callAPI(App_data.backend_api + '/checkout_v1/getExams', data).then(resp => {
      // console.log("resp", resp);

      if (resp.success) {
        this.setState({ ValidToken: true });
        this.setState({ exams: resp.exams });
        this.setState({ exam_name: resp.name });
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
    var user_data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    this.dispose = autorun(() => {
      const profileInfo = userStore.profileInfo;
      if(profileInfo == null) return;
      const { role } = profileInfo || {};
      this.setState({
        userRole: role,
      });
    });
    // FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(async resp => {
    //   if (resp) {
    //     const { profileInfo } = resp || {};
    //     const { role } = profileInfo || {};
    //     this.setState({
    //       userRole: role,
    //     });
    //   }
    // });
  }

  componentWillUnmount() {
    if(this.dispose) this.dispose();
  }

  renderExamData = (exams, ids) => {
    return exams.map((item, index) => {
      if (ids.includes(item.id)) {
        return (
          <div className='col-md-6 col-lg-6 col-xl-4 question_box free-premium-section' key={index}>
            <div
              className='question_bank_wrap pointer_class'
              onClick={this._getPackages.bind(this, item)}
            >
              <div className='margin_bottom_30'>
                <img
                  src={App_data.frontend_url + '/img/subscription/subscription_icon4.svg'}
                  alt=''
                  width='50'
                />
              </div>
              <div className='question_title'>
                <a>{item.name}</a>
              </div>
              <div className='read_more'> {language.LC().BUY_NOW} </div>
            </div>
          </div>
        );
      } else {
        return null;
      }
    });
  };

  render() {
    var domainApp = localStorage.getItem('domainApp');
    let exams = this.state.exams;
    let data = '';
    let exam_data = '';
    let soa_exam_data = '';
    let gmat_exam_data = '';
    let ea_exam_data = '';
    if (this.state.exams.length) {
      data = this.renderExamData(exams, [1, 5, 6, 17], language.LC().CFA);
      exam_data = this.renderExamData(exams, [2, 3, 4], language.LC().FRM);
      soa_exam_data = this.renderExamData(exams, [7, 8, 9, 10], language.LC().SOA);
      gmat_exam_data = this.renderExamData(exams, [13, 19], 'GMAT Exam');
      ea_exam_data = this.renderExamData(exams, [14], 'Executive Assessment Exam');
    } else {
      data = (
        <div className='loader_box'>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
            <div className='sk-circle13 sk-child' />
          </div>
        </div>
      );
    }

    return (
      <div className='animated fadeIn'>
        <div className={this.state.exam_class}>
          <div className='col-12 margin_bottom_20'>
            <h1 className='section_head'>{language.LC().PICK_YOUR_EXAM}</h1>
          </div>
          <div className='col-12 seperator-block-wrap'>
            <div className='card'>
              <div className='card-block'>
                {this.state.selectedMenu === 'soa_p' || this.state.selectedMenu === 'soa_fm' ? (
                  <div>
                    {renderExamBlock(language.LC().SOA, soa_exam_data)}
                    {renderExamBlock(language.LC().CFA, data)}
                    {renderExamBlock(language.LC().FRM, exam_data)}
                    {renderExamBlock('GMAT Exam', gmat_exam_data)}
                    {renderExamBlock('Executive Assessment Exam', ea_exam_data)}
                  </div>
                ) : this.state.selectedMenu === 'frm' ? (
                  <div>
                    {renderExamBlock(language.LC().FRM, exam_data)}
                    {renderExamBlock(language.LC().CFA, data)}
                    {renderExamBlock(language.LC().SOA, soa_exam_data)}
                    {renderExamBlock('GMAT Exam', gmat_exam_data)}
                    {renderExamBlock('Executive Assessment Exam', ea_exam_data)}
                  </div>
                ) : (
                  <div>
                    {renderExamBlock(language.LC().CFA, data)}
                    {renderExamBlock(language.LC().FRM, exam_data)}
                    {renderExamBlock(language.LC().SOA, soa_exam_data)}
                    {renderExamBlock('GMAT Exam', gmat_exam_data)}
                    {renderExamBlock('Executive Assessment Exam', ea_exam_data)}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
} */

// Function to render exam block
// const renderExamBlock = (title, examData) => (
//   <div>
//     <div className='text-center'>
//       <div className='subscription-heading-wrap'>
//         <div className='subscription-img'>
//           <img
//             src={App_data.frontend_url + '/img/subscription/subscription_icon2.svg'}
//             alt=''
//             width='30'
//           />
//         </div>
//         <h4>{title}</h4>
//       </div>
//     </div>
//     <br />
//     <div className='row plans-wrap'>{examData}</div>
//   </div>
// );

export default Subscribe;



// WEBPACK FOOTER //
// ./src/views/Subscribe/Subscribe.js